import { Root } from "./Root";
import { CreateButton } from "./CreateButton";
import {
  Search,
  TextSearch,
  BinarySearch,
  SelectSearch,
  MultiSelectSearch,
} from "./Search";
import { AutocompleteSearch } from "./AutocompleteSearch";
import { DynamicSearch } from "./DynamicSearch";
import { Sort } from "./Sort";
import {
  DataTable,
  Column,
  Actions,
  EditAction,
  DeleteAction,
  CustomAction,
} from "./DataTable";
import { FormDialog } from "./FormDialog";
import {
  FormTextField,
  SelectField,
  AutocompleteField,
  DateField,
  MultiAutocompleteField,
} from "./FormFields";
import { PasswordField } from "./PasswordField";
import { validatePassword } from "./password-utils";
import { DeleteDialog } from "./DeleteDialog";
import { Content, FieldRow, Field } from "./Layout";

export const Manager = {
  Root,
  CreateButton,
  Search,
  TextSearch,
  BinarySearch,
  SelectSearch,
  MultiSelectSearch,
  AutocompleteSearch,
  DynamicSearch,
  Sort,
  Table: DataTable,
  Column,
  Actions,
  EditAction,
  DeleteAction,
  CustomAction,
  FormDialog,
  TextField: FormTextField,
  SelectField,
  AutocompleteField,
  MultiAutocompleteField,
  DateField,
  PasswordField,
  DeleteDialog,
  Content,
  FieldRow,
  Field,
};

// Export password validation for use in form validation
export { validatePassword };

export type { FetchResult, SearchParams, SortParams } from "./types";
